module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "chartRef",
    staticClass: "echarts-container",
    style: ({
      width: _vm.width,
      height: _vm.height
    })
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5495d4f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/echarts.vue
// module id = 566
// module chunks = 4 5 6